const navbar = {
  packages: "Pakketjes", // translated
  experiences: "Ervaringen", // translated
  close: "Dichtbij", // translated
  dashboard: "Dashboard", // translated
  hotelPackages: "Hotelpakketten", // translated
  hotDeals: "Superaanbiedingen", // translated
  pricing: "Prijzen", // translated
};


export default navbar;
